"use strict";

var Color = require('color');

var basePadding = 8;
var baseMargin = 8;
var baseRadius = 0;
var baseFontSize = 1;
var largeFontSize = baseFontSize / 1.1;
var denseFontSize = baseFontSize / 1.3;
var headerFontSize = baseFontSize * 2;

var tokens = require('./tokens');

var baseBackgroundColor = tokens.colors.white;
var baseBackgroundHoverColor = 'rgba(0,0,0,.08)';
var baseTextColor = tokens.colors.black;
var headerTextColor = tokens.colors.greySwatches[900];
var primaryColor = tokens.colors.primarySwatches[800];
var primaryBackground = tokens.colors.primarySwatches[800];
var primaryTextColor = tokens.colors.white;
var secondaryTextColor = tokens.colors.white;
var secondaryBackground = tokens.colors.greySwatches[800];
var outlinedBackground = tokens.colors.white;
var inactiveColor = tokens.colors.greySwatches[300];
var idleColor = tokens.colors.greySwatches[500];
var invertIndicator = tokens.colors.greySwatches[500];
var indicator = tokens.colors.yellow;
var errorColor = tokens.colors.red;
var borderColor = tokens.colors.primarySwatches[800];
var idleBorderColor = tokens.colors.greySwatches[500];
var inputBackground = 'transparent';
var tabMenuBg = tokens.colors.white;
var inactiveIndicator = tokens.colors.greySwatches[300];
var primaryHover = '#E5F1F8';
var secondaryHover = tokens.colors.greySwatches[500];
var baseTransitionTime = .2; // seconds

var placeholderColor = tokens.colors.greySwatches[300];
var primaryActive = '#cce4f1';
var Colors = {
  "default": {
    textColor: baseTextColor,
    idleColor: idleColor,
    hoverText: '',
    border: tokens.colors.greySwatches[100],
    backgroundColor: baseBackgroundColor,
    backgroundHover: baseBackgroundHoverColor,
    headerBackgroundColor: primaryBackground,
    activeIcon: primaryColor,
    inactiveIcon: inactiveColor,
    offHandleColor: inputBackground,
    onHandleColor: primaryColor
  },
  primary: {
    textColor: primaryTextColor,
    hoverText: '',
    border: '',
    backgroundColor: primaryBackground,
    iconColor: primaryTextColor,
    backgroundHover: primaryBackground + 'CC',
    backgorundActive: primaryBackground + '99',
    headerBackgroundColor: primaryBackground,
    activeIcon: primaryColor,
    inactiveIcon: inactiveColor
  },
  secondary: {
    textColor: secondaryTextColor,
    hoverText: '',
    border: '',
    backgroundColor: secondaryBackground,
    backgroundHover: secondaryBackground + 'CC',
    backgorundActive: secondaryBackground + '99',
    iconColor: secondaryTextColor,
    headerBackgroundColor: secondaryBackground,
    activeIcon: primaryColor,
    inactiveIcon: inactiveColor
  },
  outlined: {
    textColor: primaryBackground,
    hoverText: '',
    backgroundColor: outlinedBackground,
    backgroundHover: primaryHover,
    backgorundActive: primaryActive,
    iconColor: primaryBackground,
    headerBackgroundColor: primaryBackground,
    activeIcon: primaryColor,
    inactiveIcon: inactiveColor,
    borderColor: primaryBackground
  },
  typography: {
    H1Color: baseTextColor,
    H3Color: headerTextColor,
    H2Color: headerTextColor,
    aColor: baseTextColor,
    aHoverColor: primaryBackground
  },
  switches: {
    textColor: baseTextColor,
    borderColor: tokens.colors.greySwatches[500],
    fillColor: primaryBackground,
    fillColorSecondary: tokens.colors.white,
    fillCheckColor: tokens.colors.white,
    fillCheckColorSecondary: primaryBackground,
    checkImage: function checkImage(color) {
      return 'url("data:image/svg+xml;base64,' + btoa('<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'512\' height=\'512\'><polygon fill=\'' + color + '\' points=\'424 96 184 336 88 240 48 280 184 416 464 136 424 96\'/></svg>') + '")';
    },
    minusImage: function minusImage(color) {
      return 'url("data:image/svg+xml;base64,' + btoa('<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox="0 0 512 512"><rect fill=\'' + color + '\' y="230" x="50" width="400" height="60"/></svg>') + '")';
    },
    hoverColor: 'rgba(235,235,235,0.6)',
    checkedHoverColor: 'rgba(0,122,186,0.1)',
    activeColor: 'rgba(215,215,215,0.6)',
    checkedActiveColor: 'rgba(0,124,176,0.2)',
    disabledColor: tokens.colors.greySwatches[300],
    toggleBackground: tokens.colors.greySwatches[300],
    toggleDisabledcolor: tokens.colors.greySwatches[500],
    toggleBorderColor: tokens.colors.black
  },
  inputs: {
    textColor: baseTextColor,
    errorColor: errorColor,
    borderColor: borderColor,
    idleBorderColor: tokens.colors.greySwatches[300],
    highlightBorderColor: primaryColor,
    placeholderColor: placeholderColor
  },
  header: {
    backgroundColor: tokens.colors.white,
    componentBarColor: tokens.colors.greySwatches[10]
  },
  navbar: {
    background: primaryColor,
    textColor: tokens.colors.white
  },
  tabmenu: {
    "default": {
      background: tabMenuBg,
      selectedBackground: tokens.colors.white,
      textColor: tokens.colors.greySwatches[500],
      activeTextColor: primaryBackground,
      indicator: primaryBackground,
      inactiveIndicator: inactiveIndicator,
      hoverColor: primaryBackground,
      hoverText: primaryBackground,
      activeColor: 'rgba(0, 124, 176, 0.2)',
      separatorColor: tokens.colors.greySwatches[300],
      opacity: 0.1,
      disabledColor: tokens.colors.greySwatches[300]
    },
    strong: {
      background: tabMenuBg,
      selectedBackground: tokens.colors.primarySwatches[800],
      textColor: tokens.colors.greySwatches[500],
      activeTextColor: 'white',
      indicator: primaryBackground,
      inactiveIndicator: inactiveIndicator,
      hoverColor: primaryBackground,
      hoverText: primaryBackground,
      activeColor: 'rgba(0, 124, 176, 0.2)',
      separatorColor: tokens.colors.greySwatches[300],
      disabledColor: tokens.colors.greySwatches[300]
    }
  },
  pagination: {
    border: tokens.colors.greySwatches[300]
  },
  table: {
    "default": {
      background: tokens.colors.white,
      backgroundHover: primaryHover,
      border: tokens.colors.greySwatches[300],
      headerBackground: tokens.colors.white,
      sortIconColor: tokens.colors.greySwatches[100],
      activeSortIconColor: tokens.colors.primarySwatches[800]
    },
    striped: {
      background: tokens.colors.white,
      stripeBackground: tokens.colors.greySwatches[10],
      backgroundHover: primaryHover,
      border: tokens.colors.greySwatches[300],
      headerBackground: tokens.colors.white,
      sortIconColor: tokens.colors.greySwatches[100],
      activeSortIconColor: tokens.colors.primarySwatches[800]
    },
    border: {
      background: tokens.colors.white,
      backgroundHover: primaryHover,
      border: tokens.colors.greySwatches[300],
      headerBackground: tokens.colors.greySwatches[10],
      sortIconColor: tokens.colors.greySwatches[100],
      activeSortIconColor: tokens.colors.primarySwatches[800]
    },
    dense: {
      background: tokens.colors.white,
      backgroundHover: primaryHover,
      border: tokens.colors.greySwatches[300],
      headerBackground: tokens.colors.greySwatches[10],
      sortIconColor: tokens.colors.greySwatches[100],
      activeSortIconColor: tokens.colors.primarySwatches[800]
    },
    xDense: {
      background: tokens.colors.white,
      backgroundHover: primaryHover,
      border: tokens.colors.greySwatches[300],
      headerBackground: tokens.colors.greySwatches[10],
      sortIconColor: tokens.colors.greySwatches[100],
      activeSortIconColor: tokens.colors.primarySwatches[800]
    }
  },
  footer: {
    backgroundColor: secondaryBackground,
    textColor: primaryTextColor,
    darkBacground: tokens.colors.black
  },
  tooltip: {
    primary: {
      backgroundColor: primaryBackground,
      borderColor: "transparent ".concat(primaryBackground, " transparent transparent"),
      color: primaryTextColor
    },
    secondary: {
      backgroundColor: secondaryBackground,
      borderColor: "transparent ".concat(secondaryBackground, " transparent transparent"),
      color: primaryTextColor
    }
  },
  card: {
    "default": {
      titleColor: primaryColor,
      textColor: baseTextColor,
      backgroundColor: tokens.colors.greySwatches[10]
    },
    primary: {
      titleColor: primaryColor,
      textColor: baseTextColor,
      backgroundColor: tokens.colors.white
    },
    secondary: {
      titleColor: secondaryTextColor,
      textColor: secondaryTextColor,
      backgroundColor: primaryBackground
    }
  },
  breadcrumb: {
    linkColor: primaryColor,
    activeColor: tokens.colors.greySwatches[700],
    hoverColor: primaryHover
  },
  progressIndicator: {
    defaultIndicatorColor: primaryBackground,
    backgroundColor: tokens.colors.greySwatches[300]
  },
  dropdown: {
    textColor: baseTextColor,
    placeholderColor: placeholderColor,
    backgroundColor: tokens.colors.white,
    backgroundHover: tokens.colors.greySwatches[20],
    iconColor: tokens.colors.greySwatches[500],
    shadow: '0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.2)',
    border: tokens.colors.greySwatches[50]
  },
  chip: {
    primary: {
      backgroundColor: primaryBackground,
      disabled: tokens.colors.greySwatches[500],
      color: primaryTextColor
    },
    secondary: {
      backgroundColor: secondaryBackground,
      disabled: tokens.colors.greySwatches[500],
      color: primaryTextColor
    }
  },
  dialog: {
    iconColor: tokens.colors.greySwatches[500]
  },
  snackbar: {
    backgroundColor: tokens.colors.greySwatches[900],
    textColor: primaryTextColor
  },
  slider: {
    backgroundColor: baseBackgroundColor,
    sliderBackgroundColor: tokens.colors.greySwatches[100],
    filledBackgroundColor: primaryBackground
  },
  timepicker: {
    textColor: primaryTextColor,
    backgroundColor: primaryBackground,
    blueText: primaryColor,
    whiteBackground: baseBackgroundColor,
    offwhiteBackground: tokens.colors.greySwatches[10]
  }
};
var Theme = {
  palette: Colors,
  fontFamily: 'proxima-nova, Proxima Nova, Arial, Helvetica, sans-serif',
  spacing: {
    "default": {
      borderRadius: baseRadius,
      padding: basePadding,
      margin: baseMargin,
      menuZIndex: 2000,
      baseFontSize: baseFontSize,
      headerFontSize: headerFontSize,
      transitionTime: baseTransitionTime,
      fontFamily: 'cursive',
      backgroundColor: '#f00' // TODO add typography etc to this correctly...

    },
    primary: {
      borderRadius: baseRadius,
      padding: basePadding,
      margin: baseMargin,
      baseFontSize: baseFontSize,
      headerFontSize: headerFontSize,
      largeFontSize: largeFontSize
    },
    outlined: {
      borderRadius: baseRadius,
      padding: basePadding,
      margin: baseMargin,
      baseFontSize: baseFontSize,
      headerFontSize: headerFontSize,
      largeFontSize: largeFontSize
    },
    secondary: {
      borderRadius: baseRadius,
      padding: basePadding,
      margin: baseMargin,
      baseFontSize: baseFontSize,
      largeFontSize: largeFontSize,
      headerFontSize: headerFontSize
    },
    notification: {
      padding: basePadding,
      zIndex: 2000,
      baseFontSize: baseFontSize,
      tipFontSize: 1.2,
      borderRadius: baseRadius
    },
    switches: {
      padding: basePadding,
      margin: baseMargin,
      borderRadius: baseRadius,
      width: 24,
      height: 24,
      fontSize: baseFontSize,
      errorFontSize: baseFontSize / 1.5,
      borderWidth: 2,
      toggleBackgroundHeight: 16,
      toggleBackgroundWidth: 36,
      toggleHandleDiameter: 20
    },
    typography: {
      baseFontSize: baseFontSize,
      padding: basePadding * 4,
      margin: baseMargin * 4
    },
    inputs: {
      padding: basePadding,
      margin: baseMargin,
      fontSize: baseFontSize,
      legacyErrorFontSize: baseFontSize * .6667,
      // deprecated, only used with TextBox
      errorFontSize: baseFontSize - .2,
      labelFontSize: baseFontSize - .4,
      borderRadius: baseRadius,
      underlineHeight: 2,
      dropdownOffset: 0,
      menuZIndex: 2000,
      height: 48
    },
    navbar: {
      minHeight: 64,
      fontSize: '2.0rem',
      padding: basePadding * 2,
      margin: baseMargin
    },
    header: {
      minHeight: 64,
      padding: basePadding,
      margin: baseMargin,
      height: 96,
      zIndex: 2000,
      gridWidth: 1280,
      fontSize: '2.0rem'
    },
    tabmenu: {
      height: basePadding * 6,
      minWidth: basePadding * 20,
      padding: basePadding,
      fontSize: tokens.typography.title.size,
      indicatorHeight: 2,
      inactiveIndicatorHeight: 1
    },
    footer: {
      padding: basePadding,
      margin: baseMargin
    },
    tooltip: {
      padding: basePadding,
      margin: baseMargin * 2,
      fontSize: largeFontSize,
      maxWidth: 300
    },
    card: {
      padding: basePadding,
      margin: baseMargin,
      bodyFontSize: baseFontSize + 0.4,
      headerFontSize: baseFontSize * 2,
      subtitleFontSize: baseFontSize + 0.6
    },
    breadcrumb: {
      fontSize: baseFontSize,
      padding: basePadding / 2,
      margin: baseMargin / 2
    },
    progressIndicator: {
      margin: baseMargin / 2,
      fontSize: baseFontSize,
      lineWidth: 8
    },
    dropdown: {
      "default": {
        padding: "".concat(basePadding, "px"),
        defaultPadding: basePadding,
        lineHeight: 48,
        height: 48,
        ulheight: 'fit-content',
        width: 300,
        iconSize: 15,
        fontSize: largeFontSize
      },
      dense: {
        padding: "".concat(basePadding, "px"),
        defaultPadding: basePadding,
        lineHeight: 32,
        height: 32,
        ulheight: 'fit-content',
        width: 192,
        iconSize: 15,
        fontSize: denseFontSize
      },
      xdense: {
        padding: "".concat(basePadding / 2, "px"),
        defaultPadding: basePadding / 2,
        lineHeight: 22,
        height: 22,
        ulheight: 'fit-content',
        width: 72,
        iconSize: 12,
        fontSize: denseFontSize
      }
    },
    pagination: {
      basePadding: 8
    },
    table: {
      "default": {
        fontSize: largeFontSize,
        height: 64,
        width: 840,
        fontFamily: 'Arial',
        cellHeight: 24,
        cellWidth: 192,
        basePadding: 8
      },
      striped: {
        fontSize: largeFontSize,
        height: 64,
        width: 840,
        cellHeight: 24,
        cellWidth: 192,
        basePadding: 8
      },
      border: {
        fontSize: largeFontSize,
        height: 64,
        width: 840,
        cellHeight: 24,
        cellWidth: 192,
        basePadding: 8
      },
      dense: {
        fontSize: largeFontSize,
        height: 48,
        width: 840,
        cellHeight: 24,
        cellWidth: 192,
        basePadding: 8
      },
      xDense: {
        fontSize: largeFontSize,
        height: 40,
        width: 840,
        cellHeight: 24,
        cellWidth: 192,
        basePadding: 8
      }
    },
    chip: {
      padding: basePadding / 2,
      margin: baseMargin / 2,
      fontSize: largeFontSize,
      height: 28
    },
    dialog: {
      padding: basePadding,
      margin: baseMargin,
      menuZIndex: 2000
    },
    snackbar: {
      padding: basePadding,
      margin: baseMargin,
      minWidth: 400,
      minHeight: 48,
      zIndex: 5,
      fontSize: baseFontSize
    },
    slider: {
      backgroundHeight: 4,
      backgroundWidth: 175,
      padding: basePadding,
      margin: baseMargin,
      handleDiameter: 18,
      markerHeight: 16,
      markerWidth: 2
    },
    timepicker: {
      fontSize: 36,
      height: 64,
      width: 224,
      midContainerHeight: 168,
      spacer: 22
    }
  }
};
module.exports = Theme;